export const TAB_PLAYERS_INFORMATION = 'Players Info';
export const TAB_LAST_ACTIVITY = 'Last activity';

export const isDevEnv = !!process.env.REACT_APP_IS_DEV_ENV;
export const APPLY_CHANGES = 'apply_changes';
